import { render } from "./namijuereban.vue?vue&type=template&id=f6acee26&scoped=true"
import script from "./namijuereban.vue?vue&type=script&lang=js"
export * from "./namijuereban.vue?vue&type=script&lang=js"

import "./namijuereban.vue?vue&type=style&index=0&id=f6acee26&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\work\\zhongsheng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6acee26"]])

export default __exports__